/* eslint-disable react/prop-types */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
// Packages
import React, { useState } from 'react'
import moment from 'moment'

// Components
import CitySelectComponent from './CitySelectComponent'
import CreateEditBranch from '../Branch/CreateEditBranch'

// Styles
import {
	Row,
	Col,
	Select,
	Empty
} from 'antd'
import SelectMrtStation from '../Mrt/SelectMrtStation'

// For antd
// const CheckboxGroup = Checkbox.Group
const { Option } = Select

const EachWorkingLocation = ({ company, currentUserBranches, mrtStationsList, setWorkingLocationReady, handleSelect, cities }) => {
	const [selectedBranches, setSelectedBranches] = useState(company.selectedBranches)
	// const [checkboxIndeterminate, setCheckboxIndeterminate] = useState(company.selectedBranches.length > 0 && company.selectedBranches.length < company.branches.length)
	// const [checkboxCheckall, setCheckboxCheckall] = useState(company.selectedBranches.length === company.branches.length)


	const handleSelectOptions = option => {
		setSelectedBranches(option)
		company.selectedBranches = option
		handleSelect()
	}

	const handleSelectMrtStation = (newValue) => {
		company.selectedMrtStations = newValue
		handleSelect()
	}

	const handleSelectCity = (value) => {
		company.selectedCities = value
		handleSelect()
	}

	return (
		<div style={{ margin: '1rem 0' }} id='branch-checkboxes'>
			<Row type='flex' justify='center'>
        	<Col xs={24} md={24} style={{ border: '1px dotted grey' }}>
        		<div style={{ fontSize: '0.8rem', padding: '10px' }}>
        			<div style={{ textDecoration: 'underline' }}>Admin Only View</div><br />
        			<p>
        				<span>Created by : {company.companyUserName}</span><br />
        				<span>Email : {company.companyUserEmail}</span><br />
        				<span>Created on : {moment(company.createdAt).format('Do MMMM YYYY, h:mm a')}</span>
        			</p>
        		</div>
        	</Col>
			</Row>
			{company.branchOptions.length > 0 && (
				<Row type='flex' justify='center'>
					<Col xs={24} md={24} style={{ padding: '1rem 0', backgroundColor: '#fff' }}>
						<div>
							<h4>Working Locations for {company.companyName}</h4>
							<Select
								style={{ width:'100%' }}
								defaultValue={selectedBranches}
								onChange={handleSelectOptions}
								mode='multiple'
								filterOption={(input, option) =>
									option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
								placeholder='Select Working Locations'
								optionLabelProp='label'
							>
								{company.branchOptions.map((branchOption, index) => {
									const longLabel = branchOption.label

									const getShortLabel = () => longLabel.split('-')[0]

									return (
										<Option
											key={index}
											value={branchOption.value}
											label={getShortLabel()}
										>
											{longLabel}
										</Option>
									)
								})}
							</Select>
						</div>
					</Col>
				</Row>
			)}
			{company.branchOptions.length === 0 && (
				<Row type='flex' justify='center'>
					<Col>
						<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='No Working Location added' style={{ marginTop: '2em', marginBottom: '1em' }} />
					</Col>
				</Row>
			)}
			<Row style={{ marginBottom: '1rem' }}>
				<Col xs={24} md={24}>
					<CreateEditBranch companyUserCountry={company.companyUserCountry} branchArray={company} branchCompany={company.companyId} setWorkingLocationReady={setWorkingLocationReady} handleSelect={handleSelect} />
				</Col>
			</Row>
			<Row type='flex' justify='center' style={{ margin: '1rem 0' }}>
				<Col xs={24} md={24}>
					{company.companyUserCountry === 'SG'
						? <h4>Nearest Mrt Stations for {company.companyName}</h4>
						: <h4>City</h4>}
					{company.companyUserCountry === 'SG'
						? (
							<SelectMrtStation
								mrtStationsList={mrtStationsList}
								currentUserBranches={currentUserBranches}
								onChange={handleSelectMrtStation}
								coyId={company.companyId}
							/>
						) : (
							<CitySelectComponent
								cities={cities}
								onChange={handleSelectCity}
								currentUserBranches={currentUserBranches}
								coyId={company.companyId}
							/>
						)}
				</Col>
			</Row>
			<Row type='flex' justify='center' style={{ margin: '1rem 0' }}>
				<Col xs={22} md={24}>
					<hr style={{ borderStyle: 'dashed' }} />
				</Col>
			</Row>
		</div>
	)
}

const SelectWorkingLocation = ({ currentUserBranches, checkboxCompanies, mrtStationsList, setWorkingLocationReady, handleSelect, cities }) => {

	if (currentUserBranches && currentUserBranches.length &&
    checkboxCompanies && checkboxCompanies.length &&
    ((mrtStationsList && mrtStationsList.length > 0) || (cities && cities.length > 0))) {
		// Branch has been selected
		const selectedCompanies = checkboxCompanies.map((checkedCompany) => { // Can be multiple selected companies
			return currentUserBranches.find((company) => checkedCompany === company.companyId)
		})

		const handleSelectCompanies = () => {
			handleSelect(selectedCompanies)
		}

		const display = selectedCompanies.map((company, index) => { // To consolidate and return the display to render
			return (
				<EachWorkingLocation
					key={index}
					currentUserBranches={currentUserBranches}
					company={company}
					mrtStationsList={mrtStationsList}
					setWorkingLocationReady={setWorkingLocationReady}
					handleSelect={handleSelectCompanies}
					cities={cities}
				/>
			)
		})
		return display
	} else {
		return (
			<Row type='flex' justify='center'>
				<Col xs={24} md={12}>
					<div style={{ color: 'red' }}><p>Error!</p></div>
				</Col>
			</Row>
		)
	}
}

export default SelectWorkingLocation
